import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import CategoryListingSearchNewState from "@tJohnstonCompanies/Handlers/CategoryListingSearch/CategoryListingSearchNewState";
import { Draft } from "immer";

const initialState: CategoryListingSearchNewState = {
    searchQuery: undefined,
};

const customSearchState = createTypedReducerWithImmer(initialState, {
    "CustomSearch/CategoryListingSearchNew/SetSearchQuery": (
        draft: Draft<CategoryListingSearchNewState>,
        action: { searchQuery?: string },
    ) => {
        draft.searchQuery = action.searchQuery;
    },
});

(reducers as any).customSearchState = customSearchState;

export type CustomSearchState = {
    customSearchState: CategoryListingSearchNewState;
} & ApplicationState;

type Reducers = {
    customSearchState: typeof customSearchState;
};

export type CustomSearchActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
